/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function LayoutPreset__OnePlusTwo(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'LayoutPreset__OnePlusTwo',
      'aria-hidden': true,
      focusable: false,
      width:  32 * scale,
      height: 20 * scale,
      viewBox: '0 0 32 20',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"clipPath":"url(#wf-svg-LayoutPreset__OnePlusTwo-__a)"},createElement('path', {"fill":"#D9D9D9","d":"M0 0h15v20H0z"}),createElement('path', {"stroke":"#D9D9D9","strokeOpacity":".25","d":"M.5.5h14v19H.5z"}),createElement('path', {"fill":"#D9D9D9","d":"M17 0h15v9H17z"}),createElement('path', {"stroke":"#D9D9D9","strokeOpacity":".25","d":"M17.5.5h14v8h-14z"}),createElement('path', {"fill":"#D9D9D9","d":"M17 11h15v9H17z"}),createElement('path', {"stroke":"#D9D9D9","strokeOpacity":".25","d":"M17.5 11.5h14v8h-14z"})),createElement('defs', null,createElement('clipPath', {"id":"wf-svg-LayoutPreset__OnePlusTwo-__a"},createElement('rect', {"width":"32","height":"20","rx":"2","fill":"#fff"}))))
}
